import {istDesktop, istTabletDown} from "../../../assets/js/utils";

const SELECTOR_ZURUECKSETZEN_BUTTON = '[interaction="filter-zuruecksetzen-accordion"], [interaction="filter-zuruecksetzen-button"]';
const SELECTOR_ZURUECKSETZEN_ALLE_FILTER = '[interaction="filter-entfernen-alle"]';
const SELECTOR_ANWENDEN_FILTER_BOX = '[interaction="filter-anwenden"]';
const SELECTOR_ALL_SELECTED_BEWERTUNGSFILTER = 'input:checked:not([name=sort])';
const SELECTOR_FILTER_GRUPPE = '.filter-gruppe';
const SELECTOR_OPEN_FILTER_GRUPPE = '.filter-gruppe[open]';
const SELECTOR_DROPDOWN_SUMMARY = '.filter-gruppe summary';
const SELECTOR_FILTER_BEREICH = '.filter-bereich';
const SELECTOR_SORTIERUNG_INPUT = '.filter-gruppe.sortierung input';
const SELECTOR_BEZEICHNUNG_SORT = '.filter-gruppe.sortierung .filter-bezeichnung';

const CLASS_HIGHLIGHT_ENTRY = 'element-text-standard-strong';
const CLASS_NORMAL_ENTRY = 'element-text-standard';

const CUSTOM_CHANGE_EVENT_NAME = 'bewertungs-filter-and-sort-changed';

const ATTRIBUTE_CLOSE_FILTER_BOXES = 'data-filter-schliessen';



class Bewertungsfilter extends HTMLElement {
    constructor() {
        super();
        this.currentFilterState = new Map();
        this.filterGroups = new Set();
    }

    attributeChangedCallback(name, alterWert, neuerWert) {
        if (name === ATTRIBUTE_CLOSE_FILTER_BOXES) {
            this.querySelector(SELECTOR_OPEN_FILTER_GRUPPE)?.removeAttribute('open');
            this.removeAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES);
        }
    }

    connectedCallback() {
        this.resetAllFilter();
        if (istTabletDown()) {
            this.querySelectorAll(".filter-gruppe[data-open]").forEach(this.aktiveFilterGruppenOeffnen);
        }
        this.initFilter();
        this.initOverlay();
        this.bindEvents();
        this.istAktuellDesktop = istDesktop();
    }

    bindEvents() {
        this.querySelectorAll(SELECTOR_ZURUECKSETZEN_BUTTON)?.forEach(entfernenElement => {
            entfernenElement.addEventListener('click', (event) => this.onBewertungsFilterButtonReset(event));
        });
        this.querySelectorAll(SELECTOR_ZURUECKSETZEN_ALLE_FILTER)?.forEach(entfernenElement => {
            entfernenElement.addEventListener('click', (event) => this.onBewertungsFilterAllReset(event));
        });
        this.querySelectorAll(SELECTOR_ANWENDEN_FILTER_BOX)?.forEach(anwendenElement => {
            anwendenElement.addEventListener('click', (event) => this.onFilterAnwenden(event));
        });
        this.querySelectorAll(SELECTOR_SORTIERUNG_INPUT)?.forEach(sortierungElement => {
            sortierungElement.addEventListener('click', (event) => this.onBewertungsSortChange(event));
        });

        if (istDesktop()) {
            this.querySelectorAll(SELECTOR_DROPDOWN_SUMMARY).forEach(summaryNode => {
                summaryNode.addEventListener('click', (event) => this.onSummaryClick(event));
            });
            document.addEventListener('click', (event) => this.onDocumentClick(event));
            document.addEventListener("keydown", (event) => {
                if (event.code === 'Escape') {
                    this.setAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES, '');
                }
            });
        }

        window.addEventListener('resize', () => this.onResize());
    }

    onFilterAnwenden(event) {
        const { dataset } = event.target.closest('ul');

        if (dataset && dataset.sichtbar === 'mobil') {
            this.overlay.close();
        }
        this.setAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES, '');
        this.sendBewertungsFilterAndSortChangedEvent();
    }

    onBewertungsFilterButtonReset(event) {
        const key = event.target.dataset.key;
        if (key === 'global') {
            this.onBewertungsFilterAllReset();
            this.overlay.close();
        } else {
            this.querySelectorAll(`input:checked[name=${key}]`)?.forEach(node => {
                node.checked = false;
            });
            this.setAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES, '');
            this.sendBewertungsFilterAndSortChangedEvent();
        }

    }

    onBewertungsFilterAllReset() {
        this.resetAllFilter();
        this.sendBewertungsFilterAndSortChangedEvent();
    }

    onRemoveFilter(key, value) {
        this.getFilterElement(key, value).checked = false;
        this.sendBewertungsFilterAndSortChangedEvent();
    }

    onBewertungsSortChange(event) {
        this.querySelectorAll(SELECTOR_SORTIERUNG_INPUT)?.forEach(node => {
            const parentLiNode = node.closest('li');
            if (node.value === event.target.value) {
                parentLiNode.classList.add(CLASS_HIGHLIGHT_ENTRY);
                parentLiNode.classList.remove(CLASS_NORMAL_ENTRY);
                node.checked = true;
            } else {
                parentLiNode.classList.remove(CLASS_HIGHLIGHT_ENTRY);
                parentLiNode.classList.add(CLASS_NORMAL_ENTRY);
            }
        });
        this.updateSortDropdown(event.target);
        this.setAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES, '');
        this.sendBewertungsFilterAndSortChangedEvent();
    }

    onResize() {
        // Wir waren auf Desktop und sind jetzt kleiner
        if (this.istAktuellDesktop && istTabletDown()) {
            this.querySelectorAll(".filter-gruppe[data-open]").forEach(this.aktiveFilterGruppenOeffnen);
        }
        // Wir waren auf Tablet oder kleiner und sind jetzt Desktop
        if (!this.istAktuellDesktop && istDesktop()) {
            this.querySelectorAll(".filter-gruppe[data-open]").forEach(this.aktiveFilterGruppenSchliessen);
            this.initFilter();
        }
        if (istTabletDown()) {
            document.removeEventListener('click', (event) => this.onDocumentClick(event));
        } else {
            document.addEventListener('click', (event) => this.onDocumentClick(event));
        }
        // Aktuelle Größe setzen
        this.istAktuellDesktop = istDesktop();
    }

    onDocumentClick(event) {
        if (this.isClickOnToggleButton(event.target) || this.isClickOnSummary(event.target) || this.isClickInFilter(event.target)) {
            return;
        }
        if (document.querySelector(SELECTOR_OPEN_FILTER_GRUPPE) !== null) {
            this.setAttribute(ATTRIBUTE_CLOSE_FILTER_BOXES, '');
        }
    }

    onSummaryClick(event) {
        const geoffneterFilter = this.querySelector(SELECTOR_OPEN_FILTER_GRUPPE);
        if (geoffneterFilter !== null && geoffneterFilter !== event.target.closest(SELECTOR_FILTER_GRUPPE)) {
            geoffneterFilter.removeAttribute('open');
        }
    }

    isClickOnToggleButton(target) {
        return target.classList.contains('toggle-filter-button')
    }

    isClickOnSummary(target) {
        return target.nodeName === 'SUMMARY' || target.classList.contains('filter-bezeichnung') || target.classList.contains('filter-icon-toggle');
    }

    isClickInFilter(target) {
        return target.classList.contains(SELECTOR_FILTER_BEREICH) || target.closest(SELECTOR_FILTER_BEREICH) !== null;
    }

    resetAllFilter() {
        this.querySelectorAll(SELECTOR_ALL_SELECTED_BEWERTUNGSFILTER)?.forEach(node => {
            node.checked = false;
        });
    }

    /* -------------------------------------
     * Custom Event Handling
     * -------------------------------------
     */
    sendBewertungsFilterAndSortChangedEvent() {
        const newState = this.calculateNewBewertungsFilterAndSortState();
        const eventDetails = {
            detail: newState
        };
        document.dispatchEvent(new CustomEvent(CUSTOM_CHANGE_EVENT_NAME, eventDetails));
        this.updateUiFromState(newState);
        this.currentFilterState = newState;
    }

    calculateNewBewertungsFilterAndSortState() {
        const filterAndSortState = new Map();
        this.filterGroups.forEach(groupKey => filterAndSortState.set(groupKey, new Set()));
        this.querySelectorAll('input:checked')?.forEach(node => {
            filterAndSortState.get(node.name).add(node.value);
        });
        return filterAndSortState;
    }

    updateUiFromState(newState) {
        this.updatePommes(newState);
        this.updateZuruecksetzen(newState);
    }

    updateZuruecksetzen(newState) {
        let filterCountTotal = 0;
        newState.forEach((valueSet, key) => {
            if (key !== 'sort') {
                const currentSize = valueSet.size;
                filterCountTotal += currentSize;
                const resetButtons = this.querySelectorAll(`.button-zuruecksetzen[data-key="${key}"]`);
                resetButtons.forEach(node => {
                    (currentSize > 0) ? node.classList.remove('hidden') : node.classList.add('hidden');
                });
            }
        });
        const globalButtons = this.querySelectorAll(`.button-zuruecksetzen[data-key="global"], .alle-filter-entfernen, .ihre-auswahl`);
        globalButtons.forEach(node => {
            filterCountTotal > 0 ? node.classList.remove('hidden') : node.classList.add('hidden');
        });
    }

    /* --------------------------
     *  Pommes-Handling
     * --------------------------
     */
    updatePommes(newState) {
        newState.forEach((valueSet, key) => {
            if (key !== 'sort') {
                const oldValueSet = this.currentFilterState.get(key) || new Set();
                const toDelete = new Set([...oldValueSet].filter(e => !valueSet.has(e)));
                const toAdd = new Set([...valueSet].filter(e => !oldValueSet.has(e)));

                toDelete.forEach(value => this.deletePommes(key, value));
                toAdd.forEach(value => this.addPommes(key, value));
            }
        });
    }

    addPommes(key, value) {
        const htmlLiElement = document.createElement("li");
        htmlLiElement.classList.add("element-text-standard", "pommes");
        htmlLiElement.dataset.key = key;
        htmlLiElement.dataset.value = value;

        const button = document.createElement("button");
        button.classList.add("pommes-filter");
        button.setAttribute("interaction", "filter-entfernen");
        button.innerText = this.getFilterElement(key, value).dataset.displayName;

        button.addEventListener('click', () => setTimeout(() => this.onRemoveFilter(key, value), 100));
        htmlLiElement.appendChild(button);

        const alleEntfernenElement = this.querySelector(SELECTOR_ZURUECKSETZEN_ALLE_FILTER).closest('li');
        this.querySelector('.link-pommes-liste').insertBefore(htmlLiElement, alleEntfernenElement);
    }

    deletePommes(key, value) {
        const pommesToDelete = this.querySelector(`li.pommes[data-key="${key}"][data-value="${value}"]`);
        pommesToDelete?.parentNode.removeChild(pommesToDelete);
    }

    initFilter() {
        this.querySelectorAll(SELECTOR_FILTER_GRUPPE)?.forEach(gruppenElement => {
            this.filterGroups.add(gruppenElement.dataset.key)
        });
    }

    getFilterElement(key, value) {
        return this.querySelector(`input[name="${key}"][value="${value}"]`);
    }

    updateSortDropdown(selectedSortOption) {
        this.querySelectorAll(SELECTOR_BEZEICHNUNG_SORT)?.forEach(node => node.innerText = selectedSortOption.dataset.displayName);
    }

    /*-------------------------------------------------
    ------ aktive Filtergruppen (mobil) ---------------
    -------------------------------------------------*/
    aktiveFilterGruppenOeffnen(filterGruppe) {
        filterGruppe.setAttribute('open', '');
    }

    aktiveFilterGruppenSchliessen(filterGruppe) {
        filterGruppe.removeAttribute('open');
    }

    /*-------------------------------------------------
    ------ Overlay (mobil) ----------------------------
    -------------------------------------------------*/
    initOverlay() {
        this.overlay = this.querySelector(".buchhaendler-bewertungsfilter");
        this.querySelector('[interaction="overlay-oeffnen"]').addEventListener("click", () => {
            // Damit im Safari alle Filter erreichbar sind, berechnen wir hier den Verfügbaren Platz und
            // setzen ihn in eine Custom Property
            // siehe https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
            let vh = window.innerHeight * 0.01;
            this.style.setProperty('--vh', `${vh}px`);
            this.overlay.showModal()
        });
        this.querySelector('[interaction="overlay-schliessen"]').addEventListener('click', (event) => {
            this.overlay.close();
        });
    }

    /*-------------------------------------------------
    ------ Getter & Setter ----------------------------
    -------------------------------------------------*/
    static get observedAttributes() {
        return [ATTRIBUTE_CLOSE_FILTER_BOXES];
    }
}

customElements.get("buchhaendler-bewertungsfilter") || customElements.define("buchhaendler-bewertungsfilter", Bewertungsfilter);
